/* eslint max-len: 0 */

import { RecommendationsRepository, ActivationCodesRepository, AppIntegrationsRepository, LicensesRepository, MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';

const _directiveDependencies = [];
const _controllerDependencies = ['$state', 'Util', '$scope', 'RecommendationsRestService', '$translate', '$rootScope', '$location', '$anchorScroll'];

class RecommendationBannerController {

    constructor(
        $state,
        Util, $scope, RecommendationsRestService, $translate, $rootScope, $location, $anchorScroll,
    ) {

        this.$state = $state;
        this.issues = [];
        this.$scope = $scope;
        this.Util = Util;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;

        $scope.showRecommendation = false;
        $scope.showRecommendationPrime = false;
        $scope.showRecommendationAIA = false;
        $rootScope.showRecommendation = false;
        $scope.brandName = CWCONFIG.partnerConfig.name;
        $scope.product1 = AppIntegrationsRepository.getAppName('pasm0');
        $scope.product2 = AppIntegrationsRepository.getAppName('swoe0');
        $scope.hasValidPayment = $rootScope.hasValidPayment;
        const subscriptions = ActivationCodesRepository.getAll();

        $scope.renewalPrices = CWCONFIG.cma.subscriptions.renewalPrices;

        $scope.gotoAnchor = (anchor) => {

            this.$location.hash(anchor);
            this.$anchorScroll();

        };

        const currentUserAppId = Util.deepFind(subscriptions[0], 'attributes.app');
        const recommendedApp = AppIntegrationsRepository.getById(currentUserAppId) || {};

        // hide the learn more button for app recommendations without comparison features
        if (Util.deepFind(recommendedApp, 'attributes.resource.comparisonFeatures')) {

            $scope.showLearnMoreButton = true;

        } else {

            $scope.showLearnMoreButton = false;

        }

        if (subscriptions.length > 0) {

            RecommendationsRestService.getAllAsync().then((response) => {

                RecommendationsRepository.replace(response.data.data);

            });

            // get recommendation for user
            const recommendationObservable = RecommendationsRepository.getObservable();
            const recommendationsSubscriber = recommendationObservable.subscribe((data) => {

                // recommendation is available, show banner
                if (data.length > 0) {

                    const hasPrime = LicensesRepository.getLicenseByAppId('aps10') || LicensesRepository.getLicenseByAppId('aps20');

                    if (hasPrime) {

                        const userCountry = Util.deepFind(MeRepository.getMyUser(), 'attributes.country');

                        if (userCountry === 'DE') {

                            this.recommendation = [data.find(product => product.attributes.acronym === 'adwp1')];
                            $scope.recommendationDetails = data.find(product => product.attributes.acronym === 'adwp1');

                            // show recommendation only for CB region. CA region (USA) is excluded
                            if ($scope.recommendationDetails.attributes.pg === 'CB') {

                                $scope.showRecommendation = true;
                                $scope.showRecommendationAIA = true;
                                $rootScope.showRecommendation = true;

                            }

                            const aiaRecommendation = data.find(product => product.attributes.acronym === 'adwp1');

                            // $rootScope.createCMAlabels('adwp1_12_1', 'Identity Assistant', 'adwp1', '2023-11-23', '2023-12-03');

                            $scope.recommendedProduct =
                            AppIntegrationsRepository.getById(aiaRecommendation.attributes.acronym);


                            const subscriptionsProductIds = [];
                            subscriptions.forEach((subscription) => {

                                subscriptionsProductIds.push(subscription.relationships.app.data.id);

                            });

                            const mixpanelDetails = {
                                'Recommendation ID': aiaRecommendation.id,
                                Page: 'Subscriptions',
                                'Product ID': $scope.recommendedProduct.id,
                                Product: $scope.recommendedProduct.attributes.name,
                                'User subscriptions': subscriptionsProductIds.sort().join(','),
                            };

                            Mixpanel.send('ConnectWeb OCP Recommendation Show', mixpanelDetails);

                        } else {

                            $scope.showRecommendation = false;
                            $rootScope.showRecommendation = false;

                        }

                    } else {

                        this.recommendation = data;
                        $scope.recommendationDetails = data.find(product => product.attributes.acronym === 'aps10');

                        // show recommendation only for CB region. CA region (USA) is excluded
                        if ($scope.recommendationDetails.attributes.pg === 'CB') {

                            $scope.showRecommendation = true;
                            $scope.showRecommendationPrime = true;
                            $rootScope.showRecommendation = true;

                        }

                        const primeRecommendation = data.find(product => product.attributes.acronym === 'aps10');

                        //* Promotional Campaign
                        //* To be commented when the campaign is over
                        // if (!$rootScope.cmaGBapplies) {

                        //     $rootScope.createCMAlabels(
                        //         'aps10_12_1',
                        //         'Avira Prime',
                        //         'aps10',
                        //         '2023-11-23',
                        //         '2023-12-03',
                        //     );

                        // }

                        $scope.recommendedProduct =
                            AppIntegrationsRepository.getById(primeRecommendation.attributes.acronym);

                        const recommendedProduct = AppIntegrationsRepository.getById(subscriptions[0].relationships.app.data.id);

                        let productPrototype = '';

                        // check if first product from recommendation is bundle
                        if (recommendedProduct.attributes.prototype === null && recommendedProduct.attributes.type === 'bundle') {

                            // get product prototype from app relationship
                            recommendedProduct.relationships.apps.data.forEach((app) => {

                                const appInt = AppIntegrationsRepository.getById(app.id);

                                if (appInt.attributes.prototype === 'updater'
                                    || appInt.attributes.prototype === 'passm') {

                                    productPrototype = appInt;

                                }

                            });

                        } else if (recommendedProduct.attributes.prototype === 'app') {

                            productPrototype = recommendedProduct.attributes.prototype;

                        }

                        // if product prototype exists and is software updater or password manager,
                        // the product thire feature will be updated
                        if (productPrototype) {

                            if (productPrototype.attributes.prototype === 'updater') {

                                $scope.recommendedProduct.attributes.resource.bannerFeatures[2].description = this.$translate.instant('cw.recommendation.feature.software_updater', { brandname: $scope.brandName, product: $scope.product1 });

                            } else if (productPrototype.attributes.prototype === 'passm') {

                                $scope.recommendedProduct.attributes.resource.bannerFeatures[2].description = this.$translate.instant('cw.recommendation.feature.password_manager', { brandname: $scope.brandName, product: $scope.product2 });

                            }

                        }


                        $scope.isYearlyPayment = $scope.recommendationDetails.attributes.subscription_type === 'annual';

                        const subscriptionsProductIds = [];
                        subscriptions.forEach((subscription) => {

                            subscriptionsProductIds.push(subscription.relationships.app.data.id);

                        });

                        const mixpanelDetails = {
                            'Recommendation ID': data[0].id,
                            Page: 'Subscriptions',
                            'Product ID': $scope.recommendedProduct.id,
                            Product: $scope.recommendedProduct.attributes.name,
                            'User subscriptions': subscriptionsProductIds.sort().join(','),
                        };

                        Mixpanel.send('ConnectWeb OCP Recommendation Show', mixpanelDetails);

                    }

                } else {

                    $scope.showRecommendation = false;
                    $rootScope.showRecommendation = false;

                }

            }, () => { }, () => { });

            $scope.$on('$destroy', () => {

                recommendationsSubscriber.dispose();
                $rootScope.welcomeOffers = {};

            });

        }

        eventManager.subscribe('purchase completed', () => {

            RecommendationsRestService.getAllAsync().then((response) => {

                RecommendationsRepository.replace(response.data.data);

            });

        });

        if ($scope.showRecommendation) {

            $rootScope.showCmaDisclaimer.banner = true;

        }

    }

    tryRecommendation(action, xacontent, xamedium) {

        this.$rootScope.ocp_xa_content = xacontent;
        this.$rootScope.ocp_xa_medium = xamedium;

        let ltbName = 'one-click-payment';
        let subsource;
        let promotion;
        let stateName = this.$state.current.name;

        if (stateName.indexOf('.ltb') === -1) {

            stateName += '.ltb';

        }

        // Learn More modal
        // if user doesnt have a valid payment, open payment card
        if (action === 'Learn More') {

            ltbName = 'ocp-comparison';

        } else if (this.$scope.hasValidPayment === false) {

            stateName += '.banner';
            ltbName = 'payment-cart';
            subsource = 'banner';
            promotion = true;

        }

        const mixpanelDetails = {
            Product: this.$scope.recommendedProduct.attributes.name,
            'Product ID': this.$scope.recommendedProduct.id,
            'Recommendation ID': this.recommendation[0].id,
            'Button Label': action,
            Page: 'Subscriptions',
        };

        Mixpanel.send('ConnectWeb OCP Button Click', mixpanelDetails);

        if (this.$scope.recommendedProduct.id !== 'adwp1' || action !== 'Learn More') {

            // open modal
            this.$state.go(stateName, {
                ltb: ltbName,
                resourceId: this.$scope.recommendedProduct.id,
                subsource,
                promotion,
            }, {
                reload: false,
            });

        }

    }

}

class RecommendationBannerDirective {

    constructor() {

        this.template = require('./recommendation-banner.html');
        this.restrict = 'EA';
        this.replace = true;
        this.scope = { source: '=', licenses: '=' };

        if (CWCONFIG.features.oneClickPayment) {

            _controllerDependencies.push((
                $state, DeployRestService,
                Util, $scope, $translate, $rootScope,
                $location, $anchorScroll,
            ) =>
                new RecommendationBannerController(
                    $state, DeployRestService,
                    Util, $scope, $translate, $rootScope,
                    $location, $anchorScroll,
                ));
            this.controller = _controllerDependencies;
            this.controllerAs = 'recommendationBannerController';

        }

    }

}

_directiveDependencies.push(() => new RecommendationBannerDirective());


angular.module('directives')
    .directive('recommendationBanner', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/recommendation-banner/recommendation-banner.js